import { render } from "./SubmitClaimRequest.vue?vue&type=template&id=8947a4d2"
import script from "./SubmitClaimRequest.vue?vue&type=script&lang=js"
export * from "./SubmitClaimRequest.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__